
import { useEffect } from 'react'
import { isNullOrEmpty } from '../../../../common/Helpers';
import { useDispatch } from 'react-redux';
import { action_setVariableList } from '../../../../reducers/actions/KPI/actions';

const useOnSearchMasterKpi = (searchManager, listData, setSearchManager, setListDataAux) => {    
    useEffect(()=> {
        const getData = async () => {
            setSearchManager && setSearchManager(prevState => ({
                ...prevState,
                fireSearch: false,
            }));

            setListDataAux && setListDataAux(prevState => ({
                ...prevState,
                data: listData.filter(
                    x => x.name.toLowerCase().indexOf(searchManager.text.toLowerCase()) !== -1 ||
                         x.descripcion.toLowerCase().indexOf(searchManager.text.toLowerCase()) !== -1 ),
                fireUpdate: true,
            }));
        }
        
        if (listData !== null && searchManager.fireSearch === true && searchManager.text !== "") {
            getData()
        }
    }, [searchManager, listData, setSearchManager]);
}


const useOnPresetVariableData = (listVariables, setListVariables, masterKpiSelected, setMasterKpiSelected, variableIdSelected) => {    
    useEffect(()=> {
        const getData = async () => {
            let variable = listVariables.data.find(x => x.id === variableIdSelected)

            variable.formulaId = masterKpiSelected.masterKpiItem.formulaId;
            variable.measurementPeriodId = masterKpiSelected.masterKpiItem.measurementPeriodId;
            variable.measurementUnitId = masterKpiSelected.masterKpiItem.measurementUnitId;
            variable.objetiveId = masterKpiSelected.masterKpiItem.objetiveId;
            variable.timeAggregationId = masterKpiSelected.masterKpiItem.timeAggregationId;
            variable.typeOfId = masterKpiSelected.masterKpiItem.typeOfId;

            setListVariables && setListVariables(prevState => ({
                ...prevState,
                fireUpdate: true,
                data: listVariables.data
            }));

            setMasterKpiSelected && setMasterKpiSelected(prevState => ({
                ...prevState,
                firePresetData: false
            }));
        }
        
        if (listVariables.data !== null && masterKpiSelected.masterKpiItem !== null && masterKpiSelected.firePresetData === true && variableIdSelected !== null) {
            getData()
        }
    }, [listVariables, setListVariables, masterKpiSelected, setMasterKpiSelected, variableIdSelected]);
}

const useOnPresetVariableData2 = (listVariables, masterKpiSelected, setMasterKpiSelected, variableIdSelected) => {    
    const dispatch = useDispatch();
    
    useEffect(()=> {
        const getData = async () => {
            let variable = listVariables.find(x => x.id === variableIdSelected)
            variable.formulaId = masterKpiSelected.masterKpiItem.formulaId;
            variable.measurementPeriodId = masterKpiSelected.masterKpiItem.measurementPeriodId;
            variable.measurementUnitId = masterKpiSelected.masterKpiItem.measurementUnitId;
            variable.objetiveId = masterKpiSelected.masterKpiItem.objetiveId;
            variable.timeAggregationId = masterKpiSelected.masterKpiItem.timeAggregationId;
            variable.typeOfId = masterKpiSelected.masterKpiItem.typeOfId;
            variable.masterKpiId = masterKpiSelected.masterKpiItem.id;

            setMasterKpiSelected && setMasterKpiSelected(prevState => ({
                ...prevState,
                firePresetData: false
            }));

            dispatch(action_setVariableList(listVariables))
        }
        
        if (listVariables !== null && masterKpiSelected.masterKpiItem !== null && masterKpiSelected.firePresetData === true && variableIdSelected !== null) {
            getData()
        }
    }, [listVariables, masterKpiSelected, setMasterKpiSelected, variableIdSelected]);
}

export {
    useOnSearchMasterKpi,
    useOnPresetVariableData,
    useOnPresetVariableData2
}

